import { FalUrlBuilderStrategy } from './fal-url-builder-strategy';
import { FalUrlBuilderParams } from '../url-builder-params';

export class SearchTermUrlBuilderStrategy extends FalUrlBuilderStrategy {
  shouldBuild(urlBuilderParams: FalUrlBuilderParams): boolean {
    return !this.hasGeolocationData(urlBuilderParams);
  }

  createUrlSegments(urlBuilderParams: FalUrlBuilderParams): void {
    this.addSegments('', urlBuilderParams.isService ? 's' : 't');
    if (urlBuilderParams.searchTerm) {
      this.addSegments(urlBuilderParams.searchTerm);
    }
  }
}
